import {
  CheckBadgeIcon,
  ClockIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import RPModal from "../../../Modal/RPModal";
import { useLayoutEffect, useState } from "react";
import {
  getKlacht,
  getStates,
  getUser,
  getUserdetails,
  setStates,
  setVoedingID,
} from "../../../Localstorage/localstorage";
import RpKlachtenRegisterForm from "../../klachtenregister/RpKlachtenRegisterForm";
import { AXIOS_GET } from "../../../server/api/crud";
import { KlachtenValues } from "../../../klantenregister";
import PreIntakeForm from "../preintake/PreIntakeForm";
import VoedingForm from "../voeding/VoedingForm";

const clients = (object) => [
  {
    id: 1,
    name: "Pre-Intake",
    icon: ClockIcon,
    iconWrap:
      "bg-wa-panel text-wa-accent ring-1 ring-inset ring-wa-border/70 shadow-inner",
    status: 1 + object?.preintake_verstuur,
  },
  {
    id: 2,
    name: "Klachtenregistratie formulier",
    icon: CheckBadgeIcon,
    iconWrap:
      "bg-wa-panel text-violet-600 dark:text-violet-300 ring-1 ring-inset ring-wa-border/70 shadow-inner",
    status: object?.klacht_verstuur + object?.preintake_verstuur,
  },
  {
    id: 3,
    name: "Voedingsdagboek",
    icon: UsersIcon,
    iconWrap:
      "bg-wa-panel text-sky-600 dark:text-sky-300 ring-1 ring-inset ring-wa-border/70 shadow-inner",
    status: object?.voeding_verstuur + object?.klacht_verstuur,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function InfoCards({ vragenlijst, user }) {
  const [openPreIntake, setOpenPreIntake] = useState(false);
  const [openklacht, setOpenKlacht] = useState(false);
  const [openVoeding, setOpenVoeding] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataVoeding, setFormDataVoeding] = useState(null);

  const admin = getUser();
  const adimn_details = getUserdetails();

  const [klachten, setKlachten] = useState(null);
  const [state, setState] = useState(null);
  const [klacht, setKlacht] = useState(0);
  const klachtslocal = getKlacht();
  const status = getStates();

  const openModal = (id) => {
    if (id == 1) {
      setOpenPreIntake(true);
    } else if (id == 2) {
      setOpenKlacht(true);
    } else if (id == 3) {
      setOpenVoeding(true);
    }
  };

  useLayoutEffect(() => {
    let kl = {};
    let st = {};
    if (user) {
      const fetchDataKlacht = async (id) => {
        try {
          const response = await AXIOS_GET(`klachtenregistratie/all/${id}`);
          // Loop through the object properties

          const dataKlachten = response?.data;
          let newKlacht = {};

          Object.entries(dataKlachten).map(([key, value]) => {
            let remove = key
              .replace("Data", "")
              .replace("ontlastingstoelgang", "ontlasting_stoelgang");
            if (value.length > 0) {
              newKlacht[remove] = value[0];
            } else {
              newKlacht[remove] = KlachtenValues(id)[remove];
            }
          });
          setKlachten(newKlacht);
        } catch (error) {
          setKlachten(KlachtenValues(id));
          console.error("Error fetching data:", error);
        }
      };

      const fetchdata = async () => {
        await AXIOS_GET(`klachtenregistratie/${user?.user_id}`)
          .then((resklacht) => {
            if (resklacht.data.length > 0) {
              kl = resklacht.data[0];
              st = { id: resklacht.data[0]?.status };
              setKlacht(kl);
              setState(st);
              setStates(st);
              fetchDataKlacht(kl?.id);
            } else {
              setKlacht(klachtslocal);
              setState(status);
              setStates(status);
              fetchDataKlacht(klachtslocal?.id);
            }
          })
          .catch(() => {
            setState({ id: 0 });
            fetchDataKlacht(0);
          });
      };

      fetchdata();
    }

    const fetchDataPreIntake = async (p_id) => {
      try {
        const response = await AXIOS_GET(`preintake/${p_id}`);
        if (response.data.data[0]) setFormData(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    
    fetchDataPreIntake(user?.user_id);


    const fetchDataVoeding = async (p_id) => {
      try {
        const response = await AXIOS_GET(`voedsel/${p_id}`);
        if (response.data.data[0]) setFormDataVoeding(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataVoeding(user?.user_id)
  }, [user]);


  return (
    <div>
      <ul
        role="list"
        className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8"
      >
        {clients(vragenlijst).map((client) => (
          <li
            key={client.id}
            {...(client.status > 0 && { onClick: () => openModal(client?.id) })}
            className={classNames(
              "overflow-hidden rounded-2xl border border-wa-border bg-wa-panel2/50 shadow-[0_20px_50px_-36px_rgba(0,0,0,0.55)] ring-1 ring-black/[0.04] transition dark:bg-wa-panel/40 dark:ring-white/[0.06]",
              client.status > 0
                ? "cursor-pointer hover:border-wa-accent/40 hover:shadow-[0_24px_56px_-32px_rgba(0,0,0,0.58)]"
                : "cursor-default opacity-95"
            )}
          >
            <div className="flex items-center gap-4 border-b border-wa-border/80 bg-wa-panel/50 p-5 sm:p-6">
              <span
                className={classNames(
                  "inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl",
                  client.iconWrap
                )}
              >
                <client.icon className="h-7 w-7" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <p className="text-[15px] font-semibold leading-snug text-wa-text">
                  {client.name}
                </p>
                <p className="mt-1 text-xs text-wa-muted">
                  {client.status > 0 ? "Klik om te openen" : "Nog niet beschikbaar"}
                </p>
              </div>
            </div>
            <dl className="divide-y divide-wa-border/50 px-5 py-1 text-sm sm:px-6">
              <div className="flex items-center justify-between gap-4 py-4">
                <dt className="text-[11px] font-bold uppercase tracking-wide text-wa-muted">
                  Status
                </dt>
                <dd>
                  <span
                    className={classNames(
                      "text-sm font-semibold",
                      client.status === 2
                        ? "text-emerald-600 dark:text-emerald-400"
                        : client.status === 1
                          ? "text-amber-600 dark:text-amber-400"
                          : "text-red-600 dark:text-red-400"
                    )}
                  >
                    {client.status === 2
                      ? "Verstuurd"
                      : client.status === 1
                        ? "In verwerking"
                        : "Niet verstuurd"}
                  </span>
                </dd>
              </div>
            </dl>
          </li>
        ))}
      </ul>
      <RPModal
        setOpen={setOpenPreIntake}
        open={openPreIntake}
        Component={
          <PreIntakeForm
            userdetails={user}
            admin={adimn_details}
            setOpen={setOpenPreIntake}
            formData={formData}
            setFormData={setFormData}
          />
        }
      />
      <RPModal
        setOpen={setOpenKlacht}
        open={openklacht}
        Component={
          <RpKlachtenRegisterForm
            setOpen={setOpenKlacht}
            setKlachten={setKlachten}
            admin={admin}
            klachten={klachten}
            status={state}
            klacht={klacht}
          />
        }
      />

      <RPModal
        setOpen={setOpenVoeding}
        open={openVoeding}
        Component={
          <VoedingForm
            userdetails={user}
            admin={admin}
            setOpen={setOpenVoeding}
            formData={formDataVoeding}
            setFormData={setFormDataVoeding}
          />
        }
      />
    </div>
  );
}
